import React, { createContext, useContext, useEffect, useState } from "react";
import { authMe, authLogout, getToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    if (!getToken()) { setUser(null); setLoading(false); return null; }
    try { const u = await authMe(); setUser(u); return u; }
    catch { setUser(null); return null; }
    finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);
  const logout = async () => { try { await authLogout(); } catch {} setUser(null); };

  return <AuthCtx.Provider value={{ user, setUser, loading, refresh, logout }}>{children}</AuthCtx.Provider>;
}
